export default{
    en:{
        tab:{
            menu:'Menu Management',
            role:'Role',
            commonCode:'Common Code',
        },
        list:{
            menu:{
                all:'All',
                menu:'Menu',
                subMenu:'Sub Menu',
                tab:'Tab',
                menuType:'Menu Type',
                menuId:'ID',
                i18nCode:'Menu Name',
                dispOrder:'Sort',
                useYn:'Use',
            },
            role:{
                roleId:'권한코드',
                roleNm:'권한명',
                i18nCode:'메뉴명',
                permitLevel:'접근권한',
                none:'없음',
                read:'조회',
                modify:'수정',
                delete:'삭제',
                admin:'관리자',
                reload:'권한 갱신',
            },
            commonCode:{
                codeDiv:'분류코드',
                divKor:'분류코드(한글명)',
                divEng:'분류코드(영문명)',
                codeList:'세부코드 수',
                useYn:'사용유무',
            },
        },
        detail:{
            menu:{
                menuId:'ID',
                i18nCode:'Menu Name (다국어 코드)',
                dispOrder:'Sort',
                useYn:'Use',
                useY:'사용',
                useN:'미사용',
                menuDscrp:'정렬',
            },
            commonCode:{
                codeDiv:'분류코드',
                divKor:'분류코드(한글명)',
                divEng:'분류코드(영문명)',
                useYn:'사용유무',
                useY:'사용함',
                useN:'사용안함',
                remark:'Remark',
                code:'코드명',
                nmKor:'코드(한글명)',
                nmEng:'코드(영문명)',
                ref1:'Ref1',
                ref2:'Ref2',
                ref3:'Ref3',
                ord:'정렬',
            },
        },
    },
    ko:{
        tab:{
            menu:'메뉴관리',
            role:'권한관리',
            commonCode:'공통코드관리',
        },
        list:{
            menu:{
                all:'전체',
                menu:'메뉴(MENU)',
                subMenu:'서브 메뉴(SUB MENU)',
                tab:'탭(TAB)',
                menuType:'메뉴타입',
                menuId:'ID',
                i18nCode:'메뉴명',
                dispOrder:'Sort',
                useYn:'Use',
            },
            role:{
                roleId:'권한코드',
                roleNm:'권한명',
                i18nCode:'메뉴명',
                permitLevel:'접근권한',
                none:'없음',
                read:'조회',
                modify:'수정',
                delete:'삭제',
                admin:'관리자',
                reload:'권한 갱신',
            },
            commonCode:{
                codeDiv:'분류코드',
                divKor:'분류코드(한글명)',
                divEng:'분류코드(영문명)',
                codeList:'세부코드 수',
                useYn:'사용유무',
            },
        },
        detail:{
            menu:{
                menuId:'메뉴 ID',
                i18nCode:'메뉴명 (다국어 코드)',
                dispOrder:'정렬',
                useYn:'사용여부',
                useY:'사용',
                useN:'미사용',
                menuDscrp:'정렬',
            },
            commonCode:{
                codeDiv:'분류코드',
                divKor:'분류코드(한글명)',
                divEng:'분류코드(영문명)',
                useYn:'사용유무',
                useY:'사용함',
                useN:'사용안함',
                remark:'비고',
                code:'코드명',
                nmKor:'코드(한글명)',
                nmEng:'코드(영문명)',
                ref1:'Ref1',
                ref2:'Ref2',
                ref3:'Ref3',
                ord:'정렬',
            },
        },
    }
}